module.exports = __webpack_public_path__ + "static/media/infiniti-logo.8cfb479e.svg";